import { FormEvent, useState } from "react";
import { authenticate } from "../lib/translation";

interface AuthDialogProps {
  onClose: () => void;
  onAuthenticated: () => void;
}

export function AuthDialog({
  onClose,
  onAuthenticated
}: AuthDialogProps) {
  const [passphrase, setPassphrase] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await authenticate(passphrase);
      onAuthenticated();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "登录失败。");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <form
        className="dialog-card auth-dialog"
        onSubmit={submit}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="dialog-icon lock-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="5" y="10" width="14" height="10" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
          </svg>
        </div>
        <h2>连接翻译服务</h2>
        <p>输入你在 Cloudflare Worker 中设置的访问口令。模型 API Key 不会进入浏览器。</p>
        <label>
          访问口令
          <input
            autoFocus
            type="password"
            value={passphrase}
            onChange={(event) => setPassphrase(event.target.value)}
            placeholder="输入访问口令"
            autoComplete="current-password"
          />
        </label>
        {error && <div className="field-error">{error}</div>}
        <div className="dialog-actions">
          <button type="button" className="secondary-button" onClick={onClose}>
            取消
          </button>
          <button
            type="submit"
            className="primary-button"
            disabled={busy || !passphrase}
          >
            {busy ? "正在验证…" : "登录并开始翻译"}
          </button>
        </div>
      </form>
    </div>
  );
}
